export const isDropExpired = (drop) => {
    const { expirationDate } = drop;
    if (!expirationDate) {
        return false;
    }
    return new Date(expirationDate) < new Date();
};
